import React, { MouseEventHandler } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import BannerIdentifacation from 'images/Banner-Identifacation-Contract.png';
import messages from 'containers/ExpertHomePage/messages';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { SearchQuery } from 'containers/ExpertHomePage/typings';
import SearchBarExpert from 'containers/ExpertHomePage/SearchBarExpert';

export interface IdentificationPageProps {
  intl: IntlShape;
  submitSearch: Function;
  refreshSearch: MouseEventHandler;
  searchQuery: SearchQuery;
  onChangeSearchQuery: Function;
}

const Container = styled.div`
  &&.container {
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(${BannerIdentifacation});
    background-position: center;
    background-repeat: no-repeat;
    height: 219px;
    width: 100%;
    box-shadow: 0px 1px 2px #0000001f;
    margin-top: ${props => (props.hidden ? '50px' : '75px')};
  }
  .searchContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .inputContainer {
    display: flex;
    margin-top: 28px;
  }
  .input {
    padding: 2px 4px;
    height: 46px;
    width: 30%;
    border-radius: 4px;
    margin: 0px 5px;
    border: 1px solid #0279c2;
    background-color: #fafafa;
  }
  .inputTextStyle {
    text-align: left;
    font: Regular 14px Roboto;
    letter-spacing: 0;
    color: #707891;
    padding: 10px 0;
    width: 200px;
  }
  .containerSearch {
    margin-top: 10px;
  }
  .inputTextStyleDate {
    text-align: left;
    font: Regular 14px Roboto;
    letter-spacing: 0;
    color: #707891;
    padding: 5px 0;
  }
  .inputBase {
    margin-left: 5px;
    flex: 1;
  }
  .title {
    text-align: center;
    font: Bold 24px Roboto;
    letter-spacing: 0;
    color: #ffffff;
    margin-bottom: 18px;
  }
  .subTitle {
    text-align: center;
    font: Regular 14px Roboto;
    letter-spacing: 0;
    color: #ffffff;
  }
  .searchButton {
    width: 126px;
    height: 46px;
    padding: 2px 4px;
    background-color: #f9be00;
    border: 1px solid #f9be00;
    text-align: center;
    font: Medium 15px Roboto;
    letter-spacing: 0.03px;
    color: #333e48;
    border-radius: 4px;
    margin: 0px 5px;
  }
  .dateInput {
    background: #fafafa 0 % 0 % no - repeat padding - box;
    height: 100%;
    border: none;
  }
  .error {
    margin-top: 10%;
    color: red;
  }
  .error-5 {
    margin-top: 8%;
    color: red;
  }
`;

const SearchContainer: React.FC<IdentificationPageProps> = (
  props,
): JSX.Element => {
  return (
    <Container className="container">
      <div className="searchContainer">
        <Typography className="title">
          {translate({ ...messages.searchTitle }, props)}
        </Typography>
        <Typography className="subTitle">
          {translate({ ...messages.searchSubTitle }, props)}
        </Typography>
        {featureService.hasFeature(FEATURES.SEARCH_BAR) && (
          <div className="containerSearch">
            <SearchBarExpert
              searchQuery={props.searchQuery}
              setSearchQuery={props.onChangeSearchQuery}
              handlerSearch={props.submitSearch}
              handlerRefresh={props.refreshSearch}
            />
          </div>
        )}
      </div>
    </Container>
  );
};

export default injectIntl(SearchContainer);
